<template>
	<div class="share" v-if="showShare">
		<el-dialog
			title="分享"
			:visible.sync="dialogShare"
			class="changephone_box share_box1"
			:close-on-click-modal="false"
			:width="isPhone === 'true' ? '85%' : '408px'"
			:before-close="closedBtn"
			append-to-body
			:showClose="isPhone === 'true' ? false : true"
		>
			<a :title="fileInfo.fileName" slot="title" class="dialog-title">
				分享
				<span>{{ fileInfo.fileName | limitFileName(15) }}</span>
			</a>
			<!-- 设置权限 -->
			<div class="content" v-if="status === 'readPage'">
				<p class="qx">文档权限：</p>
				<el-checkbox-group
					v-model="checkPermission"
					@change="changeCheckbox"
					:disabled="checkList == -1"
				>
					<template
						v-if="(!['jpg', 'png', 'bmp', 'ppt', 'pptx', 'tiff', 'tif'].includes(fileInfo.fileType))"
					>
						<el-checkbox label="permissionCopy">复制</el-checkbox>
					</template>
					<el-checkbox label="permissionDownload">下载</el-checkbox>
					<el-checkbox label="permissionPrint">打印</el-checkbox>
				</el-checkbox-group>
				<p class="sx">访问时效：</p>
				<el-radio-group v-model="checkList" @change="changeRadio">
					<el-radio :label="1">永久有效</el-radio>
					<el-radio :label="2">30天有效</el-radio>
					<el-radio :label="3">7天有效</el-radio>
					<el-radio :label="-1">阅后即焚</el-radio>
				</el-radio-group>
				<p class="time" v-if="time">该链接 {{ time }} 前有效</p>
				<p class="shareUrl_box">
					文档链接：
					<span class="shareUrl">{{ shareUrl }}</span>
				</p>
			</div>
			<!-- 查看权限 -->
			<div class="content" v-if="status === 'shareReadPage'">
				<h4
					v-if="fileInfo.permissionCopy != 1 || fileInfo.permissionDownload != 1 || fileInfo.permissionPrint != 1"
				>
					文件由
					<span v-if="nickname">{{ nickname }}</span> 分享，作者已设置权限
				</h4>
				<p
					class="qx"
					style="margin-bottom: 24px;"
					v-if="fileInfo.permissionCopy != 1 || fileInfo.permissionDownload != 1 || fileInfo.permissionPrint != 1"
				>
					文档权限：
					<span>{{ permissionTxt }}</span>
				</p>
				<!-- <ul v-if="fileInfo.permissionCopy != 1 || fileInfo.permissionDownload != 1 || fileInfo.permissionPrint != 1">
					<li v-if="fileInfo.permissionCopy != 1">
						可复制
					</li>
					<li v-if="fileInfo.permissionDownload != 1">
						<span></span>
						下载
					</li>
					<li v-if="fileInfo.permissionPrint != 1">
						<span></span>
						打印
					</li>
				</ul>-->
				<p v-if="fileInfo.expiredDate">
					访问时效：
					<span>
						该文档
						<strong>{{ fileInfo.expiredDate }}</strong>前有效
					</span>
				</p>
				<p class="shareUrl_box">
					文档链接：
					<span class="shareUrl">{{ shareUrl }}</span>
				</p>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="copyUrl" size="mini" class="mini">复制链接</el-button>
				<el-button @click="closedBtn" size="mini" class="mini">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { shareCreate } from "@comm/api/document-conversion";
import { formatDate, copyText } from "@comm/utils/tools";
import { getUserInfo } from "@comm/utils/auth";
export default {
	name: "Share",
	data() {
		return {
			checkPermission: [],
			checkList: 0,
			dialogShare: true,
			time: "",
			isChange: false,
			oldTime: "",
			oldTime2: "",
			isPhone: null,
			permissionTxt: '',
			userInfo: null,
			nickname:null
		};
	},
	props: {
		showShare: false,
		shareUrl: "",
		fileInfo: {},
		status: ''//readPage shareReadPage
	},
	watch: {
		fileInfo() {
			if (!this.fileInfo.fileId) {
				this.checkPermission = [];
				this.checkList = 1;
				this.isChange = false;
			}
		},
		showShare() {
			this.userInfo = getUserInfo() ? JSON.parse(getUserInfo()) : null;
			if (!this.isChange) {
				this.checkPermission[0] = this.fileInfo.permissionCopy != 1 && !['jpg', 'png', 'bmp', 'ppt', 'pptx', 'tiff', 'tif'].includes(this.fileInfo.fileType) ? "permissionCopy" : "";
				this.checkPermission[1] = this.fileInfo.permissionDownload != 1 ? "permissionDownload" : "";
				this.checkPermission[2] = this.fileInfo.permissionPrint != 1 ? "permissionPrint" : "";
				if (this.status === 'shareReadPage') {
					let k = [], bk = []
					if (this.fileInfo.permissionCopy != 1 && !['jpg', 'png', 'bmp', 'ppt', 'pptx', 'tiff', 'tif'].includes(this.fileInfo.fileType)) {
						k.push('复制')
					} else {
						bk.push('复制')
					}
					if (this.fileInfo.permissionDownload != 1) {
						k.push('下载')
					} else {
						bk.push('下载')
					}
					if (this.fileInfo.permissionPrint != 1) {
						k.push('打印')
					} else {
						bk.push('打印')
					}
					let ktest = '', bktest = ''
					if (k.length == 1) {
						ktest = '可' + k[0] + '，'
					} else if (k.length > 1 && k.length != 3) {
						ktest = '可' + k.join('、') + '，'
					} else if (k.length == 3) {
						ktest = '可' + k.join('、')
					}
					if (bk.length == 1) {
						bktest = '不可' + bk[0]
					} else if (bk.length > 1) {
						bktest = '不可' + bk.join('、')
					}
					this.permissionTxt = ktest + bktest
				}
				this.checkList = this.fileInfo.expiredType ? this.fileInfo.expiredType : this.checkList;
				this.time = this.fileInfo.expiredDate
					? this.fileInfo.expiredDate
					: this.fileInfo.expiredType == 1 || this.fileInfo.expiredType == -1 || !this.fileInfo.expiredType
						? ""
						: this.fileInfo.expiredType == 2
							? this.oldTime
							: this.oldTime2;
			}
		}
	},
	// computed: {
	// 	shareUrl() {
	// 		console.log(7,this.shareUrl)
	// 		return decodeURIComponent(this.shareUrl);
	// 	},
	// },
	created() {
		this.isChange = false;
		this.nickname = localStorage.nickname
		this.isPhone = localStorage.getItem("isPhone");
		this.checkPermission.push(this.fileInfo.permissionCopy != 1 && !['jpg', 'png', 'bmp', 'ppt', 'pptx', 'tiff', 'tif'].includes(this.fileInfo.fileType) ? "permissionCopy" : "");
		this.checkPermission.push(this.fileInfo.permissionDownload != 1 ? "permissionDownload" : "");
		this.checkPermission.push(this.fileInfo.permissionPrint != 1 ? "permissionPrint" : "");
		this.checkList = this.fileInfo.expiredType ? this.fileInfo.expiredType : 1;
	},
	methods: {
		changeCheckbox() {
			this.isChange = false;
		},
		changeRadio() {
			this.isChange = false;
			this.time = "";
			// this.fileInfo.expiredDate=""
			let time = new Date().getTime();
			let date = "";
			if (this.checkList == 2) {
				date = new Date().getTime() + 60000 * 60 * 24 * 30;
				this.time = formatDate(new Date(parseInt(date)), "yyyy/MM/dd hh:mm:ss");
				this.oldTime = this.time;
			} else if (this.checkList == 3) {
				date = new Date().getTime() + 60000 * 60 * 24 * 7;
				this.time = formatDate(new Date(parseInt(date)), "yyyy/MM/dd hh:mm:ss");
				this.oldTime2 = this.time;
			}
		},
		copyUrl() {
			this.isChange = true;
			this.fileInfo.expiredDate = this.time;
			let permissionCopy = 1;
			let permissionDownload = 1;
			let permissionPrint = 1;
			this.checkPermission.forEach((item) => {
				if (item == "permissionCopy") {
					permissionCopy = 0;
				} else if (item == "permissionDownload") {
					permissionDownload = 0;
				} else if (item == "permissionPrint") {
					permissionPrint = 0;
				}
			});
			copyText(this.shareUrl)
			this.closedBtn();
			if (this.status === 'shareReadPage') {
				return
			}
			shareCreate({
				expiredType: this.checkList,
				fileId: this.fileInfo.fileId,
				permissionCopy,
				permissionDownload,
				permissionPrint
			}).then((res) => {
				this.fileInfo.permissionCopy = permissionCopy;
				this.fileInfo.permissionDownload = permissionDownload;
				this.fileInfo.permissionPrint = permissionPrint;
				this.fileInfo.expiredType = this.checkList;
			})
				.catch(() => {
					this.isChange = false;
				})
		},
		closedBtn() {
			if (!this.isChange) {
				this.checkPermission = [];
				this.checkList = 1
				this.time = this.fileInfo.expiredDate;
			}

			// this.checkPermission = [];
			// this.checkList = 0;
			this.$emit("closeBtn", false);
		}
	}
};
</script>
<style lang="scss">
.share_box1 {
	.el-checkbox__label,
	.el-radio__label {
		font-size: 12px !important;
	}
	.el-radio {
		margin-right: 18px !important;
		width: 70px;
	}
	.el-dialog__body {
		padding-bottom: 0 !important;
	}
}
</style>
<style lang="scss" scoped>
.share_box1 {
	.dialog-title {
		font-size: 16px;
		font-family: MicrosoftYaHei;
		color: #36425a;
		text-decoration: none;
		line-height: 21px;
		span {
			font-size: 12px;
			font-family: MicrosoftYaHei;
			color: #666666;
			line-height: 16px;
			margin-left: 18px;
		}
	}
	.content {
		font-size: 12px;
		color: #36425a;
		line-height: 16px;
		h4 {
			font-size: 12px;
			margin-bottom: 24px;
			span {
				color: #64ccff;
			}
		}
		.qx {
			margin-bottom: 16px;
		}
		.sx {
			margin: 24px 0 16px;
		}
		.time {
			font-size: 12px;
			margin-top: 10px;
			color: #9b9a9a;
			line-height: 16px;
		}
		p {
			span {
				margin-left: 8px;
				strong {
					color: #14a8f0;
					font-weight: normal;
				}
				&.shareUrl {
					margin-left: 4px;
					width: 80%;
					height: 30px;
					vertical-align: middle;
					line-height: 30px;
					padding: 0 8px;
					background: #ffffff;
					border: 1px solid #dadada;
					display: inline-block;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}
			&.shareUrl_box {
				margin: 24px 0 40px;
			}
		}
		ul {
			display: flex;
			align-items: center;
			margin-bottom: 42px;
			li {
				margin-right: 56px;
				span {
					display: inline-block;
					width: 16px;
					height: 16px;
					margin-right: 2px;
					vertical-align: middle;
					background: url("../../../images/document-conversion/zxyl/dg_icon.png")
						0 0 no-repeat;
					background-size: 100%;
				}
			}
		}
	}
	.mini {
		width: 72px !important;
		height: 30px !important;
	}
	.is-checked {
		.el-checkbox__inner {
			background-color: #14a8f0 !important;
			border-color: #14a8f0 !important;
		}
		.el-radio__label {
			color: #14a8f0 !important;
		}
		.el-radio__inner {
			background-color: #14a8f0 !important;
			border-color: #14a8f0 !important;
		}
	}
	.is-disabled {
		.el-checkbox__inner {
			background-color: #f2f6fc !important;
			border-color: #dcdfe6 !important;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/comm/components/document-conversion/shareBox/index.vue